import state from '../state'
import breakpoints from '@/libs/breakpoints'

export default {
  data: function () {
    return {
      limit: 12,
      offset: 0,
      loading: false,
      hasMore: true,
      stateObjectKey: state.objectKey,
      defaultSort: 'recent_activity'
    }
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  methods: {
    getTabContent: function (filter) {
      if (this.loading || !this.hasMore || !this.user.userName) {
        return
      }
      this.loading = true
      if (this.$isEngCom) {
        this.defaultSort = 'published'
      }
      const params = { username: this.user.userName, limit: this.limit, offset: this.offset, filter, sort: this.defaultSort }
      this.$store.dispatch('getProjectsForUser', params).then((response) => {
        this.loading = false
        if (filter === 'project') {
          this.projects.push.apply(this.projects, response.projects)
        } else {
          this.stories.push.apply(this.stories, response.projects)
        }
        this.hasMore = response.hasMore
        this.offset += this.limit
      }, () => {
        this.loading = false
      })
    }
  }
}
